const isArabLang = isArabicLocale()

// Function to add or update a query parameter in the current URL
const addOrUpdateQueryParam = (key, value, remove = false) => {
    const url = new URL(window.location.href)
    url.searchParams.set(key, value)
    if (remove) {
        url.searchParams.delete(key, value)
    }
    window.history.replaceState({}, '', url.toString())
}

const getQueryParams = (paramKey = null) => {
    const queryParams = new URLSearchParams(window.location.search)
    const params = {}
    for (const [key, value] of queryParams) {
        params[key] = value
    }
    params.page = params.page || 1;

    // return specified paramKey when present
    if (paramKey) {
        return params[paramKey]
    }
    return params
}

// This function will format the product price as per the selected country and shop money format
const formatMoney = (cents, format) => {

    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    let value = '';
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let formatString = (format || Shopify.nosto.money_format.split('{{').pop().split('}}')[0]);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        let parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            if (Object.keys(COUNTRY_CURRENCY_CODE).includes(Shopify?.country)) {
                let decimalPart = (value % 1).toFixed(2) * 100;
                if (decimalPart < 50) {
                    value = `${parseInt(value).toFixed()}.50`
                } else {
                    value = Math.ceil(value).toFixed(2)
                }
            }
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

const swArrowDownSvg = `<svg class="sw-down-arrow">
                           <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" 
                            fill="currentColor"></path>
                        </svg>`

// currency code and symbol by country
const COUNTRY_CURRENCY_CODE = {
    'BH': {
        code: 'BHD',
        symbol: isArabLang ? ".د.ب" : 'BHD'
    },
    'OM': {
        code: 'OMR',
        symbol: isArabLang ? '.ع.ر' : 'OMR'
    },
    'KW': {
        code: 'KWD',
        symbol: isArabLang ? 'ك.د' : 'KWD'
    },
}

// below mention conversion rates are calculated based on AED as base
// Base currency AED
const CONVERSIONS = {
    'BHD': 0.1026,
    'OMR': 0.1048,
    'KWD': 0.0833
}

const convertCurrency = amount => {

    const currency = COUNTRY_CURRENCY_CODE[window.Shopify.country]
    if (currency && CONVERSIONS[currency.code]) {
        return amount * CONVERSIONS[currency.code]
    }
    return amount
}

const convert__Currency = amount => {

    const currency = COUNTRY_CURRENCY_CODE[window.Shopify.country]
    if (currency && CONVERSIONS[currency.code]) {
        let finalPrice = 0.00;
        let convertedPriceValue = amount * CONVERSIONS[currency.code];
        let decimalPart = (convertedPriceValue % 1).toFixed(2) * 100;
        if (decimalPart < 50) {
            let addDecimalPart = 0.50
            finalPrice = (convertedPriceValue + addDecimalPart)
        } else {
            finalPrice = Math.ceil(convertedPriceValue)
        }
        return finalPrice
    }
    return amount
}

const getCurrency = defaultCurrency => {

    const currency = COUNTRY_CURRENCY_CODE[window.Shopify.country]
    if (currency && currency.symbol) {
        return currency.symbol
    }
    return defaultCurrency
}

// class LocalDBManager {
//     constructor(dbName, dbVersion = 1, storeName = 'products', keyPath = 'id') {
//         this.dbName = dbName
//         this.dbVersion = dbVersion
//         this.storeName = storeName
//         this.keyPath = keyPath
//         this.db = null

//         // Open (or create) the database
//         this._initDatabase()
//     }

//     // Private method to open (or create) the database
//     _initDatabase() {
//         const request = indexedDB.open(this.dbName, this.dbVersion)

//         request.onerror = function (event) {
//             console.error("Error opening database:", event.target.errorCode)
//         }

//         request.onupgradeneeded = function (event) {
//             this.db = event.target.result

//             // Create an object store if it doesn't exist
//             if (!this.db.objectStoreNames.contains(this.storeName)) {
//                 this.db.createObjectStore(this.storeName, {
//                     keyPath: this.keyPath,
//                     autoIncrement: this._isAutoIncrement()
//                 })
//             }
//         }.bind(this)

//         request.onsuccess = function (event) {
//             this.db = event.target.result
//         }.bind(this)
//     }

//     _isAutoIncrement() {
//         return this.keyPath === 'id'
//     }

//     // Method to add an item to the database
//     addItem(item) {
//         const transaction = this.db.transaction([this.storeName], 'readwrite')
//         const objectStore = transaction.objectStore(this.storeName)

//         const request = objectStore.add(item)

//         request.onsuccess = function (event) {
//             // console.log('Item added to database')
//         }

//         request.onerror = function (event) {
//             console.error('Error adding item:', event.target.error)
//         }
//     }

//     // Method to get an item from the database by its ID
//     async getItem(key) {
//         const transaction = this.db.transaction([this.storeName], 'readonly')
//         const objectStore = transaction.objectStore(this.storeName)

//         const request = objectStore.get(key)

//         try {
//             const event = await new Promise((resolve, reject) => {
//                 request.onsuccess = resolve
//                 request.onerror = reject
//             })

//             return event.target.result
//         } catch (error) {
//             console.error('Error getting item:', error)
//             return null
//             // throw error
//         }
//     }

//     // Method to delete an item from the database by its ID
//     deleteItem(itemId) {
//         const transaction = this.db.transaction([this.storeName], 'readwrite')
//         const objectStore = transaction.objectStore(this.storeName)

//         const request = objectStore.delete(itemId)

//         request.onsuccess = function (event) {
//             // console.log('Item deleted from database')
//         }

//         request.onerror = function (event) {
//             console.error('Error deleting item:', event.target.error)
//         }
//     }
// }

class LocalDBManager {
    constructor(collectionName = 'products', keyPath = 'id') {
        this.collectionName = collectionName;
        this.keyPath = keyPath
    }

    // Method to add an item to localStorage
    addItem(item) {
        const key = this._generateKey(item);
        let collection = JSON.parse(localStorage.getItem(this.collectionName))
        if (collection === null) {
            collection = {}
        }
        collection[key] = item

        localStorage.setItem(this.collectionName, JSON.stringify(collection))
    }

    // Method to get an item from localStorage by its key
    getItem(key) {
        const collection = JSON.parse(localStorage.getItem(this.collectionName))
        if (collection && collection[key]) {
            return collection[key];
        } else {
            return null;
        }
    }

    // Method to delete an item from localStorage by its key
    deleteItem(key) {
        const collection = JSON.parse(localStorage.getItem(this.collectionName))
        if (collection && collection[key]) {
            delete collection[key]
        }

        localStorage.setItem(this.collectionName, JSON.stringify(collection))
    }

    // Private helper method to generate a key based on the item (optional)
    _generateKey(item) {
        return item[this.keyPath] || Math.random().toString(36).substring(2, 15);
    }
}

/* This contains everything related to nosto Graph Api configuration */
const NostoConfig = {
    accountId: 'shopify-61894623460',
    localDbName: 'SW_GL_PLP_COLLECTION',
    excludedFacets: ['gender'], // names of facets to be excluded on frontend
    sizeOrder: ["S", "M", "L", "XL", "XXL"],
    sizeFacetKey: 'skus.customFields.size',
    colorFacetKey: 'extra.Color',
    facetType: {
        term: 'terms',
        stats: 'stats',
    },
    apiUrl: 'https://api.nosto.com/v1/graphql',
    searchApiUrl: 'https://search.nosto.com/v1/graphql',
    defaultPageSize: 40,
    sortUrlKey: 'products.sort',
    pageSizeUrlKey: 'page',
    filterUrlKey: 'products.filter',
    // For additional translations please insert the wording in lowercase followed by a translation
    translateFacet: {
        'color': 'اللون',
        'beige': 'بيج',
        'black': 'أسود',
        'blue': 'أزرق',
        'brown': 'بني',
        'camo': 'تمويه',
        'green': 'أخضر',
        'grey': 'رمادي',
        'khaki': 'كاكي',
        'maroon': 'كستنائي',
        'orange': 'برتقالي',
        'peach': 'خوخي',
        'pink': 'وردي',
        'purple': 'بنفسجي',
        'red': 'أحمر',
        'white': 'أبيض',
        'yellow': 'أصفر',
        'fit': 'المقاس',
        'athletic fit': 'قصة رياضية',
        'relaxed fit': 'قصة مريحة',
        'oversized fit': 'قصّة واسعة',
        'regular fit': 'قصة عادية',
        'high impact': 'عالية التأثير',
        'medium impact': 'متوسطة التأثير',
        'low impact': 'منخفضة التأثير',
        'product type': 'نوع المنتج',
        'accessories': 'اكسسوارات',
        'bodysuit': 'بودي سوت',
        'cap': 'قبعات',
        'catsuit': 'بدلة كاملة',
        'donation': 'تبرع',
        'hoodies': 'هوديز',
        'jacket': 'جاكتات',
        'joggers': 'جوقرز',
        'leggings': 'بناطيل ضيقة',
        'shorts': 'شورتات',
        'sports bra': 'حمالة صدر رياضية',
        't-shirts': 'تيشيرتات',
        'tank / stringers': 'سترينقرز / تانكس',
        'tanks': 'تانكس',
        'tights': 'بناطيل ضيقة',
        'gender': 'الجنس',
        'female': 'أنثى',
        'male': 'ذكر',
        'unisex': 'لكلا الجنسين',
        'price': 'السعر',
        'size': 'المقاس'
    },
    // For additional translations please insert the wording in lowercase followed by a translation
    translateBadge: {
        'athletic fit': 'قصة رياضية',
        'relaxed fit': 'قصة مريحة',
        'oversized fit': 'قصّة واسعة',
        'oversize fit': 'قصّة واسعة',
        'regular fit': 'قصة عادية',
        'high impact': 'عالية التأثير',
        'medium impact': 'متوسطة التأثير',
        'mid impact': 'متوسطة التأثير',
        'low impact': 'منخفضة التأثير',
        'adjustable': 'قابل للتعديل',
        'adjustable fit': 'قابل للتعديل',
        'built-in bra': 'حمالة صدر مدمجة',
        'heavy': 'ثقيل',
        'inner phone pocket': 'جيب داخلي للهاتف',
        'seamless': 'بدون خياطة',
        'recycled': 'معاد تدويره',
        'light': 'خفيف',
        'medium': 'متوسط',
        'high rise': 'ارتفاع عالي',
        'organic cotton': 'قطن عضوي',
        'limited time offer': 'عروض لفترة محدودة',
        'double layered': 'طبقتين'
    },
    sortLabel: isArabLang ? `تصنيف حسب` : `Sort By`,
    sortOptions: [
        {
            id: "price",
            value: {
                name: isArabLang ? "السعر، من الأقل إلى الأعلى" : "Price, low to high",
                sort: [
                    {
                        field: "price",
                        order: "asc",
                    },
                ],
            },
        },
        {
            id: "-price",
            value: {
                name: isArabLang ? "السعر، من الأعلى إلى الأقل" : "Price, high to low",
                sort: [
                    {
                        field: "price",
                        order: "desc",
                    },
                ],
            },
        },
        {
            id: "name",
            value: {
                name: isArabLang ? "أبجديًا، من أ إلى ي" : "Alphabetically, A-Z",
                sort: [
                    {
                        field: "name",
                        order: "asc",
                    },
                ],
            },
        },
        {
            id: "-name",
            value: {
                name: isArabLang ? "أبجديًا، من ي إلى أ" : "Alphabetically, Z-A",
                sort: [
                    {
                        field: "name",
                        order: "desc",
                    },
                ],
            },
        },
        {
            id: "datePublished",
            value: {
                name: isArabLang ? "التاريخ، من القديم إلى الجديد" : "Date, old to new",
                sort: [
                    {
                        field: "datePublished",
                        order: "asc",
                    },
                ],
            },
        },
        {
            id: "-datePublished",
            value: {
                name: isArabLang ? "التاريخ، من الجديد إلى القديم" : "Date, new to old",
                sort: [
                    {
                        field: "datePublished",
                        order: "desc",
                    },
                ],
            },
        },
        {
            id: "score",
            value: {
                name: isArabLang ? "الأكثر مبيعا" : "Bestsellers",
                sort: [
                    {
                        field: "score",
                        order: "desc",
                    },
                ],
            },
        }
    ]
}

class NostoGraphQLClient {

    constructor() {
        this.apiUrl = NostoConfig.apiUrl
        this.accountId = NostoConfig.accountId
        this.size = NostoConfig.defaultPageSize
        this.from = 0
        this.total = 0
        this.sorter = []
        this.selects = []
        this.facets = []
        this.data = []
        this.loading = false
        this.collectionId = null
        // this.localDb = new LocalDBManager(NostoConfig.localDbName, 1, 'products', 'handle')
        this.pageNo = getQueryParams().page
        this.nextPage = getQueryParams().page
        this.prevPage = 0
        this.loadMoreScrollIntoView = false
        this.position = "beforeend"

        this.initParamsFromUrl()

    }

    initParamsFromUrl = () => {

        const params = getQueryParams()
        let swPlpProdObj = getCookie('sw_plp_prod_obj');
        if (history.state && history.state.hasOwnProperty('pageNo')) {
            swPlpProdObj = JSON.parse(swPlpProdObj)
            this.pageNo = parseInt(swPlpProdObj.pageNo)
            this.prevPage = this.pageNo - 1
            this.nextPage = this.pageNo + 1
            addOrUpdateQueryParam(NostoConfig.pageSizeUrlKey, swPlpProdObj.pageNo)
        }
        // setting prevPage on init
        if (params.page > 1) {
            this.prevPage = this.pageNo - 1
        }

         // Disable automatic scroll restoration
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }

        // catch sort from url
        if (this.hasActiveSort()) {
            this.sorter = NostoConfig.sortOptions[this.getActiveSortIndex()]?.value?.sort
        }

        // catch page size from url
        if (this.hasPageSize(params)) {
            this.size = NostoConfig.defaultPageSize
        }

        // catch facets from url
        if (this.hasActiveFacets(params)) {

            let filters = []

            const isValidFacet = (params, key) => {
                return ![NostoConfig.pageSizeUrlKey, NostoConfig.sortUrlKey].includes(key) &&
                    params[key] !== undefined &&
                    params[key] !== ''
            }

            for (const key in params) {
                if (!isValidFacet(params, key)) {
                    continue;
                }

                const field = key.substring(NostoConfig.filterUrlKey.length + 1);
                const filter = { field };

                if (field === 'price') {

                    let range = {}
                    const [minPrice, maxPrice] = params[key].split('~');

                    if (minPrice && minPrice.length) {
                        range['gte'] = minPrice;
                    }
                    if (maxPrice && maxPrice.length) {
                        range['lte'] = maxPrice;
                    }
                    range = [range]
                    filter['range'] = range
                } else {
                    filter.value = decodeURIComponent(params[key]).split(',');
                }

                filters.push(filter);
            }
            this.selects = filters
        }

        console.log(typeof(this.pageNo),"typeof(this.pageNo)")
        
    }

    scrollLoadMore = () => {
        const loadMoreTrigger = document.getElementById("load-more");
        const footer = document.getElementById("shopify-section-footer");

        if (loadMoreTrigger) {
            // Intersection Observer callback
            const handleIntersection = (entries) => {
                if (entries[0].isIntersecting && !this.loading) {
                    // Check if the footer is in view
                    const footerRect = footer.getBoundingClientRect();
                    const footerInView = footerRect.top < window.innerHeight && footerRect.bottom > 0;

                    // If the footer is not in view, call onLoadMore
                    if (!footerInView) {
                        this.loading = true
                        this.onLoadMore()
                    }
                }
            };

            // Create a new Intersection Observer instance
            const observer = new IntersectionObserver(handleIntersection, {
                rootMargin: '1000px',  // load the image before 1000px in view
                threshold: 0.01  // Trigger when even a small portion of the image is visiblew
            });

            // Start observing the sentinel element
            observer.observe(loadMoreTrigger);
        }
    }

    scrollOnProduct = () => {

        const prevBtn = document.getElementById('swPlpLoadPrev')
        const productsDiv = document.getElementById('products')
        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                productsDiv.firstElementChild.scrollIntoView({
                    behavior: 'smooth', // Smooth scroll effect
                    block: 'end'     // Scroll to the center of the view
                });
            })
        }
       
    }

    useSearchApi = () => {
        this.apiUrl = NostoConfig.searchApiUrl
        return this
    }

    useCoreApi = () => {
        this.apiUrl = NostoConfig.apiUrl
        return this
    }

    pageSize = size => {

        if (!Number.isInteger(size)) {
            throw new Error('Size must be a number')
        }

        if (Number.isInteger(size) && parseInt(size) <= 0) {
            throw new Error('Size must be greater than zero')
        }

        this.size = size
        return this
    }

    offset = from => {
        if (!Number.isInteger(from)) {
            throw new Error('from must be a number')
        }

        if (Number.isInteger(from) && parseInt(from) <= 0) {
            throw new Error('Size must be greater than zero')
        }
        this.from = from
        return this
    }

    sort = (sorter = {}) => {
        this.sorter = sorter
        return this
    }

    filter = filter => {

    }

    startLoading = () => {
        const swPlpSkeleton = document.getElementById('swPlpSkeleton')
        const swPlpLoadMore = document.getElementById('swPlpLoadMore')

        if (swPlpLoadMore) {
            swPlpLoadMore.disabled = true;
            swPlpLoadMore.style.cursor = 'not-allowed';
            swPlpLoadMore.innerHTML = `<div class="sw-plp-spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>`
        }
        if (swPlpSkeleton) {
            swPlpSkeleton.innerHTML = `<div class="sw-plp-skeleton__content page-width">
              <div class="sw-plp-skeleton__filter-btns">
                <div class="small-line skeleton skeleton-text">.</div>
                <div class="medium-line skeleton skeleton-text">.</div>
              </div>
              <div class="sw-plp-skeleton__product-cards">
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
                <div class="sw-plp-skeleton__product-card">
                  <div class="img skeleton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="24" viewBox="0 0 41 24" fill="none">
                      <path d="M6.11521 7.74291L12.2304 7.54631L17.1772 24L15.6294 4.93006L0 0L6.11521 7.74291Z" fill="#A4A4A4"/>
                      <path d="M24.8704 4.93006L23.3226 24L28.2694 7.54631L34.3846 7.74291L40.4999 0L24.8704 4.93006Z" fill="#A4A4A4"/>
                    </svg>
                  </div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                  <div class="txt skeleton skeleton-text">.</div>
                </div>
              </div>
            </div>`;
        }
        this.loading = true
    }

    endLoading = () => {
        const swPlpSkeleton = document.getElementById('swPlpSkeleton')
        const swPlpLoadMore = document.getElementById('swPlpLoadMore')

        if (swPlpLoadMore) {
            swPlpLoadMore.disabled = false;
            swPlpLoadMore.style.cursor = 'pointer';
            swPlpLoadMore.innerHTML = `Load More`
        }
        if (swPlpSkeleton) {
            swPlpSkeleton.innerHTML = '';
        }
        this.loading = false
    }

    fetchData = async (query, variables = {}) => {
        this.startLoading() // loader starts

        const response = await fetch(this.apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query, variables }),
        })

        // this.endLoading() // loader end

        if (!response.ok) {
            throw new Error(`Nosto Graph API request failed with status: ${response.status}`)
        }

        return await response.json()
    }

    getPaginationInfo = () => {
        let totalPercentage = ((this.size * this.pageNo) / this.total) * 100
        let pageSize = this.size * this.pageNo
        if (this.total <= pageSize) {
            pageSize = this.total
        }

        return `<div class="sw-plp-filters-pagination__numbers-text">Viewing 1-${pageSize} out of ${this.total} products</div>
        <div class="sw-plp-filters-pagination__numbers-line"><span style="width: ${totalPercentage}%"></span></div>`
    }

    onLoadMore = async () => {
        
        this.loadMoreScrollIntoView = true
        this.position = "beforeend"
        this.pageNo = this.nextPage

        await this
            .collection(this.collectionId)
        addOrUpdateQueryParam(NostoConfig.pageSizeUrlKey, this.nextPage - 1)
        this.render()

    }

    onLoadPrev = async () => {

        this.position = "afterbegin"
        this.pageNo = this.prevPage

        await this
            .collection(this.collectionId)
        addOrUpdateQueryParam(NostoConfig.pageSizeUrlKey, this.prevPage)

        this.prevPage = this.prevPage - 1

        this.render()
    }

    getLoadMore = () => {
        if (this.nextPage <= Math.ceil(this.total / NostoConfig.defaultPageSize)) {
            return `<button id="swPlpLoadMore" onclick="swNosto().onLoadMore()">Load More</button>`
        }
        return ''
    }

    getLoadPrev = () => {
        if (this.data.products && this.prevPage > 0 && this.from <= this.total) {
            return `<button id="swPlpLoadPrev" onclick="swNosto().onLoadPrev()">Load previous</button>`
        }
        return ''
    }

    collection = async (collectionId, filters = {}) => {
        this.localDb = new LocalDBManager(`products_${collectionId}`, 'handle')
        const startIndex = (this.pageNo - 1) * this.size;

        const sessionParams = await this.getSessionParamsForRequest()
        const query = `query (
            $accountId: String,
            $sessionParams: InputSearchQuery,
            $sorter: [InputSearchSort!],
            $filter: [InputSearchTopLevelFilter!]
        ) {
            search(
                accountId: $accountId,
                products: {
                    categoryId: "${collectionId}"
                    facets: ["*"]
                    size: ${this.size} 
                    from: ${startIndex > 50000 ? 50000 : startIndex}
                    sort: $sorter
                    filter: $filter
                },
                sessionParams: $sessionParams
            ) {
                products {
                  hits {
                    productId
                    name
                    imageUrl
                    price
                    priceCurrencyCode
                    url
                    saleable
                    available
                    onDiscount
                    alternateImageUrls
                    tags1
                    skus {
                      id
                      price
                      availability
                      name
                    }
                  }
                  facets { 
                    ... on SearchTermsFacet {
                      id 
                      field 
                      type
                      name
                      data { 
                        value
                        count
                        selected
                      } 
                    } 
                    ... on SearchStatsFacet {
                      id
                      field
                      type
                      name
                      min
                      max
                    }
                  }
                  total
                  size
                  from
                }
                redirect
            }
        }`

        const response = await this.fetchData(
            query,
            {
                'accountId': this.accountId,
                'sorter': this.sorter,
                'filter': this.selects,
                sessionParams
            })

        if (response?.data?.search?.products?.facets.length) {
            this.facets = response?.data?.search?.products?.facets
        }

        this.data = response?.data?.search || []
        this.collectionId = collectionId
        this.setPaginationInfo() // setting pagination info
        
        return this
    }

    setPaginationInfo = () => {
        this.from = this.data?.products?.from || 0
        this.total = this.data?.products?.total || 0

        let currentPage = (this.from / NostoConfig.defaultPageSize) + 1
        let totalPages = Math.ceil(this.total / NostoConfig.defaultPageSize)
        let nextPage = currentPage + 1
        if (totalPages >= nextPage && nextPage > this.nextPage && totalPages > this.nextPage) {
            this.nextPage = nextPage
        } else if (totalPages < nextPage) {
            this.nextPage++
        }
    }

    applySort = async (sorter) => {
        // reset page no and update query params
        this.pageNo = 1
        this.nextPage = 1
        this.prevPage = 0

        await this
            .sort(sorter)
            .collection(this.collectionId)

        document.getElementById('products').innerHTML = ''

        addOrUpdateQueryParam(`${NostoConfig.pageSizeUrlKey}`, this.pageNo)

        addOrUpdateQueryParam(NostoConfig.sortUrlKey, `${sorter[0].field}~${sorter[0].order}`)
        this.render()
        this.swTransitionUnset()
    }

    hasActiveSort = (arg = null) => {
        const params = arg ?? getQueryParams()

        return params[NostoConfig.sortUrlKey] !== undefined && params[NostoConfig.sortUrlKey] !== null
    }

    hasActiveFacets = (arg = null) => {
        const params = arg ?? getQueryParams()

        if (params[NostoConfig.filterUrlKey] === undefined && params[NostoConfig.filterUrlKey] === null) {
            return false
        }

        for (let key in params) {
            if (key.startsWith(NostoConfig.filterUrlKey)) {
                return true
            }
        }
        return false
    }

    hasPageSize = (arg = null) => {
        const params = arg ?? getQueryParams()

        return params[NostoConfig.pageSizeUrlKey] !== undefined && params[NostoConfig.pageSizeUrlKey] !== null
    }

    getActiveSort = () => {
        const params = getQueryParams()

        if (params[NostoConfig.sortUrlKey] === undefined) {
            return null
        }

        const [field, order] = params[NostoConfig.sortUrlKey].split('~')

        return NostoConfig.sortOptions.find(option =>
            option.value.sort.every(
                v1 => v1.field === field && v1.order === order
            )
        )?.id ?? null
    }

    getActiveSortIndex = () => NostoConfig.sortOptions.indexOf(
        NostoConfig.sortOptions.find(
            option => option.id === this.getActiveSort()
        )
    )

    getSortToolbar = () => {

        let activeSortIndex = null

        if (window.location.href.indexOf('sort=') > -1 && this.hasActiveSort()) {
            activeSortIndex = this.getActiveSortIndex()
        }

        // Create the HTML structure using template literals
        return NostoConfig.sortOptions.map((sort, index) => `
                        <button type="button" value="${sort.id}"
                                onclick="swNosto().applySort(NostoConfig.sortOptions[${index}]?.value?.sort)"
                                class="btn ${activeSortIndex === index && window.location.href.indexOf('sort=') > -1 ? 'active' : ''}">
                            ${sort.value.name}
                        </button>
                    `).join('')
    }

    applyFilter = async (key, value, removing = false) => {
        let filterVal = [value]
        const filterIndex = this.selects.findIndex(filter => filter.field === key)

        if (filterIndex > -1) {

            if (this.selects[filterIndex].value.includes(value)) {
                // if value is already selected than deselect that filter value
                filterVal = this.selects[filterIndex].value.filter(val => val !== value)
            } else {
                // if the filter is not already selected than add
                filterVal = this.selects[filterIndex].value.concat(value)
            }

            if (filterVal.length) {
                this.selects[filterIndex].value = filterVal
            } else {
                this.selects = this.selects.filter((val, ind) => ind !== filterIndex)
            }
        } else {
            this.selects.push({ field: key, value: filterVal })
        }
        this.pageNo = 1
        this.nextPage = 1
        this.prevPage = 0
        document.getElementById('products').innerHTML = ''

        addOrUpdateQueryParam(`${NostoConfig.pageSizeUrlKey}`, this.pageNo)
        addOrUpdateQueryParam(`${NostoConfig.filterUrlKey}.${key}`, filterVal, filterVal.length === 0)
        await this.collection(this.collectionId)
        this.render()

        if (!removing) {
            this.swTransitionUnset();
        }
    }

    applyRangeFilter = async (event, field, type) => {

        const value = Math.round(event.target.value / window.Shopify.currency.rate).toString()
        const key = type === 'min' ? 'gte' : 'lte'
        const filterIndex = this.selects.findIndex(filter => filter.field === field)

        let filterVal = {};
        filterVal[key] = value

        if (filterIndex > -1 && this.selects[filterIndex].range.length) {
            filterVal = this.selects[filterIndex].range[0]
            filterVal[key] = value
            this.selects[filterIndex].range = [filterVal]
        } else {
            this.selects.push({ field: field, range: [filterVal] })
        }

        let queryParamValue = ''
        if (filterVal.hasOwnProperty('gte')) {
            queryParamValue = queryParamValue.concat(filterVal['gte'])
        }
        if (filterVal.hasOwnProperty('lte')) {
            queryParamValue = queryParamValue.concat('~').concat(filterVal['lte'])
        }

        addOrUpdateQueryParam(`${NostoConfig.filterUrlKey}.${field}`, queryParamValue, Object.keys(filterVal).length === 0)

        await this.collection(this.collectionId)

        document.getElementById('products').innerHTML = ''

        this.render()

        this.swTransitionUnset()
    }

    removeRangeFilter = async field => {
        this.pageNo = 1
        this.nextPage = 1
        this.prevPage = 0
        this.selects = this.selects.filter(filter => filter.field !== field)

        addOrUpdateQueryParam(`${NostoConfig.filterUrlKey}.${field}`, '', true)
        addOrUpdateQueryParam(`${NostoConfig.pageSizeUrlKey}`, this.nextPage)

        document.getElementById('products').innerHTML = ''

        await this.collection(this.collectionId)
        this.render()
    }

    clearAllFilters = async () => {
        this.pageNo = 1
        this.nextPage = 1
        this.prevPage = 0
        this.selects = [] // clearing all selected filters

        let url = new URL(window.location.href);

        // Create a new URLSearchParams object to store filtered params
        let newSearchParams = new URLSearchParams();

        // Iterate through all query parameters
        for (let [key, value] of url.searchParams) {
            // Check if the current parameter key includes page size or sort
            if ([NostoConfig.sortUrlKey].includes(key)) {
                // Keep this parameter by adding it to newSearchParams
                newSearchParams.append(key, value);
            }
        }

        // Update the URL object's search parameters with the filtered ones
        url.search = newSearchParams.toString();

        // set the updated URL
        window.history.replaceState({}, '', url.toString())
        document.getElementById('products').innerHTML = ''

        await this.collection(this.collectionId)
        this.render()
    }

    getSelectedFilters = () => {

        let selected = '';

        this.selects.forEach(filter => {

            if (filter.value && filter.value.length) {

                selected += filter.value.map(val =>
                    `<button class="sw-plp-selected-filters__btn" type="button">
                        ${val}
                        <span class="sw-facet-icon-close" onclick="swNosto().applyFilter('${filter.field}', '${val}', true)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                <path d="M0.911697 7.85123C0.811744 7.94777 0.677873 8.00119 0.538917 7.99998C0.399961 7.99877 0.267039 7.94304 0.168779 7.84478C0.0705183 7.74652 0.014782 7.61359 0.0135745 7.47464C0.012367 7.33568 0.0657848 7.20181 0.162323 7.10186L3.22289 4.04129L0.161793 0.980731C0.111175 0.931843 0.0708012 0.873363 0.0430262 0.808705C0.0152511 0.744047 0.000631495 0.674505 2.001e-05 0.604136C-0.000591475 0.533767 0.0128175 0.463982 0.0394647 0.398851C0.066112 0.33372 0.105464 0.274548 0.155224 0.224788C0.204984 0.175027 0.264156 0.135676 0.329287 0.109029C0.394418 0.0823817 0.464204 0.0689716 0.534573 0.0695834C0.604941 0.0701947 0.674484 0.084815 0.739142 0.11259C0.8038 0.140365 0.862279 0.180739 0.911167 0.231357L3.97226 3.29192L7.03282 0.231357C7.13278 0.134819 7.26665 0.0814013 7.4056 0.0826087C7.54456 0.0838161 7.67748 0.139552 7.77574 0.237812C7.874 0.336072 7.92974 0.468995 7.93095 0.607951C7.93215 0.746907 7.87874 0.880778 7.7822 0.980731L4.72163 4.04129L7.7822 7.10186C7.87874 7.20181 7.93215 7.33568 7.93095 7.47464C7.92974 7.61359 7.874 7.74652 7.77574 7.84478C7.67748 7.94304 7.54456 7.99877 7.4056 7.99998C7.26665 8.00119 7.13278 7.94777 7.03282 7.85123L3.97226 4.79067L0.911697 7.85123Z" fill="#454545"></path>
                            </svg>
                       </span>
                    </button>`
                ).join('')
            } else {
                const facet = this.getFacets().find(facet => facet.field === filter.field)
                selected += filter.range.map(({ lte, gte }) => {
                    let min = gte || facet.min
                    let max = lte || facet.max
                    min = Math.round(min * Shopify.currency.rate)
                    max = Math.round(max * Shopify.currency.rate)

                    return `<button class="sw-plp-selected-filters__btn" type="button">
                        ${min}~${max}
                        <span class="sw-facet-icon-close" onclick="swNosto().removeRangeFilter('${filter.field}')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                <path d="M0.911697 7.85123C0.811744 7.94777 0.677873 8.00119 0.538917 7.99998C0.399961 7.99877 0.267039 7.94304 0.168779 7.84478C0.0705183 7.74652 0.014782 7.61359 0.0135745 7.47464C0.012367 7.33568 0.0657848 7.20181 0.162323 7.10186L3.22289 4.04129L0.161793 0.980731C0.111175 0.931843 0.0708012 0.873363 0.0430262 0.808705C0.0152511 0.744047 0.000631495 0.674505 2.001e-05 0.604136C-0.000591475 0.533767 0.0128175 0.463982 0.0394647 0.398851C0.066112 0.33372 0.105464 0.274548 0.155224 0.224788C0.204984 0.175027 0.264156 0.135676 0.329287 0.109029C0.394418 0.0823817 0.464204 0.0689716 0.534573 0.0695834C0.604941 0.0701947 0.674484 0.084815 0.739142 0.11259C0.8038 0.140365 0.862279 0.180739 0.911167 0.231357L3.97226 3.29192L7.03282 0.231357C7.13278 0.134819 7.26665 0.0814013 7.4056 0.0826087C7.54456 0.0838161 7.67748 0.139552 7.77574 0.237812C7.874 0.336072 7.92974 0.468995 7.93095 0.607951C7.93215 0.746907 7.87874 0.880778 7.7822 0.980731L4.72163 4.04129L7.7822 7.10186C7.87874 7.20181 7.93215 7.33568 7.93095 7.47464C7.92974 7.61359 7.874 7.74652 7.77574 7.84478C7.67748 7.94304 7.54456 7.99877 7.4056 7.99998C7.26665 8.00119 7.13278 7.94777 7.03282 7.85123L3.97226 4.79067L0.911697 7.85123Z" fill="#454545"></path>
                            </svg>
                       </span>
                    </button>`
                }
                )
            }
        })

        if (selected.length) {
            selected = `<div class="sw-plp-selected-filters__grp-btn"><button class="sw-plp-selected-filters__btn" type="button" onclick="swNosto().clearAllFilters()">
                            Clear All
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
                                <path d="M1 9.78052C1 10.4513 1.59994 11 2.33334 11H7.66669C8.40006 11 9 10.4513 9 9.78052V2.75H1V9.78052ZM10 0.916667H7.5L6.66297 0H3.33706L2.5 0.916667H0V1.83333H10V0.916667Z" fill="white"></path>
                            </svg>
                    </button>${selected}`
        }
        selected += `</div>`
        return selected
    }

    getFacetsToolbar = () => {
        const facets = this.getFacets()

        if(!facets.length){
            return ''
        }

        const getFacetTerms = facet =>
            // Sort facet data based on the custom order
            facet.field === NostoConfig.sizeFacetKey ?
                facet.data.sort((a, b) => NostoConfig.sizeOrder.indexOf(a.value) - NostoConfig.sizeOrder.indexOf(b.value)) :
                facet.data


        const renderFacet = facet => {

            switch (facet.type) {
                case NostoConfig.facetType.term:
                    return getFacetTerms(facet).map(filter => {
                        return `<button type="button" 
                                        value="${facet.field}"
                                        onclick="swNosto().applyFilter('${facet.field}', '${filter.value}')"
                                        class="btn ${filter.selected ? 'active' : ''}">
                            <span class="sw-circle sw-circle__${filter.value}" ${facet.field === NostoConfig.colorFacetKey ? `style="background: ${filter.value}"` : ''}></span> 
                            ${(NostoConfig.translateFacet[filter.value.toLowerCase()] && isArabLang) ? NostoConfig.translateFacet[filter.value.toLowerCase()] : filter.value}
                        </button>`
                    }).join('')
                    break
                case NostoConfig.facetType.stats:
                    const min = Math.round(facet.min * Shopify.currency.rate)
                    const max = Math.round(facet.max * Shopify.currency.rate)
                    let swIndicatorStep = Math.round((max - min) / 5) || 1;
                    let swIndicatorsHtml = ``;
                    let lastIndex = min;

                    for (let index = min; index <= max; index += swIndicatorStep) {
                        swIndicatorsHtml += `<div class="sw-indicator">${index}</div>`;
                        lastIndex = index;
                    }
                    if (lastIndex < max) {
                        swIndicatorsHtml += `<div class="sw-indicator">${max}</div>`;
                    }
                    return `<div class="sw-range-slider">
                                <div class="sw-input sw-min-value">
                                    <label>${window.Shopify.currency.active}</label>
                                    <span>-</span>
                                    <input type="number" id="minValue" class="value" min="${min}" max="${max}" 
                                        oninput="swNosto().applyRangeFilter(event, '${facet.field}', 'min')"
                                    >
                                </div>
                                <div class="sw-range-lines">
                                    <div class="sw-range-line">
                                        <div class="slider-track"></div>
                                        <div id="sliderTrackHigh" class="slider-track-highlight"></div>
                                        <div class="slider-thumb" id="minThumb">${min}</div>
                                        <div class="slider-thumb" id="maxThumb">${max}</div>
                                    </div>
                                    <div class="sw-range-indicators">
                                        ${swIndicatorsHtml}
                                    </div>
                                </div>
                                <div class="sw-input sw-max-value">
                                    <label>${window.Shopify.currency.active}</label>
                                    <span>-</span>
                                    <input type="number" id="maxValue" class="value" min="${min}" max="${max}"
                                            oninput="swNosto().applyRangeFilter(event, '${facet.field}', 'max')"
                                     >
                                </div>
                            </div>`
                    break
                default:
                    return facet.name
            }
        }

        return `
        <div class="sw-plp-grid-btn">
            <div id="swPlpGridBtnFour" class="sw-plp-btn-four">
                <span class="sw-plp-btn-icon"></span>
                <span class="sw-plp-btn-icon"></span>
                <span class="sw-plp-btn-icon"></span>
                <span class="sw-plp-btn-icon"></span>
            </div>
            <div id="swPlpGridBtnTwo" class="sw-plp-btn-two">
                <span class="sw-plp-btn-icon"></span>
                <span class="sw-plp-btn-icon"></span>
            </div>
        </div>
        <div class="sw-plp-filters__wrapper-top"><div id="swFilterDrawerBtn" class="sw-plp-filters__heading">
            <svg class="icon-filter" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" d="M4.833 6.5a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0ZM4.05 7H2.5a.5.5 0 0 1 0-1h1.55a2.5 2.5 0 0 1 4.9 0h8.55a.5.5 0 0 1 0 1H8.95a2.5 2.5 0 0 1-4.9 0Zm11.117 6.5a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0ZM13.5 11a2.5 2.5 0 0 1 2.45 2h1.55a.5.5 0 0 1 0 1h-1.55a2.5 2.5 0 0 1-4.9 0H2.5a.5.5 0 0 1 0-1h8.55a2.5 2.5 0 0 1 2.45-2Z" fill="currentColor"></path></svg>
            ${Shopify.locale === 'ar' ? 'تحديد' : 'Filters'}
        </div>
        <div id="swFilterDrawer" class="sw-plp-filters__grp-btn ">
            <div class="sw-filter-drawer-overlay"></div>
            <div class="sw-filterdrawer-content">
                <div class="sw-filter-drawer-heading-mob">Filters <span id="swFilterDrawerCloseBtn" class="sw-filter-drawer-close-btn"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M10 0.875L9.125 0L5 4.125L0.875 0L0 0.875L4.125 5L0 9.125L0.875 10L5 5.875L9.125 10L10 9.125L5.875 5L10 0.875Z" fill="black"></path></svg></span></div>
        `
            .concat(facets
                .map(facet =>
                    `<div class="sw-plp-filters__btn">
                        <div class="sw-plp-filters__btn-txt-arrow">
                         ${(NostoConfig.translateFacet[facet.name.toLowerCase()] && isArabLang) ? NostoConfig.translateFacet[facet.name.toLowerCase()] : facet.name}
                            ${swArrowDownSvg} </div>
                        <div class="sw-plp-filters__card sw-plp-filters__card-${facet.name}">
                            ${renderFacet(facet)}
                        </div>
                    </div>`)
                .join(''))
            .concat(`<div class="sw-plp-filters__btn">
                        <div class="sw-plp-filters__btn-txt-arrow"> ${NostoConfig.sortLabel} ${swArrowDownSvg} </div>
                        <div class="sw-plp-filters__card sw-plp-filters__card-sort">
                            ${this.getSortToolbar()}
                        </div>
                    </div>`)
            .concat(`<div class="sw-filter-drawer-grp-btn-mob">
                        <button id="swFilterDrawerSeeResult"> see results </button>
                        <button onclick="swNosto().clearAllFilters()"> clear all </button>
                    </div>
                </div></div></div>`)

    }

    getProductCollection = () => {

        const getUrl = product => {

            let segment = this.getLocale().substring(1)
            let url = product.url

            if (segment.length) {
                url = product.url.replace(
                    '.com/products',
                    '.com/'
                    + segment +
                    '/products'
                )
            }
            const origin = new URL(url).origin
            const newOrigin = new URL(window.location.href).origin

            return url.replace(origin, newOrigin)
        }

        const products = this.get()?.products?.hits || []
        const dynamicHeight = products.length <= 4 ? 620 : products.length > 4 && products.length <= 8 ? 1240 : products.length > 8 && products.length <= 16 ? 1860 : 2000

        return `<div class="sw-plp-filters-products__content" style="min-height: ${dynamicHeight}px" data-page-no="${this.pageNo}">`.concat(
            products.map((product, index) => {
                let discountTag = ''
                let swCollectionsSwatches = product.skus.map((item, index) => `
                <div class="variation ee_add_to_cart ${item.availability == 'InStock' ? 'available' : 'unavailable'}" 
                        type="radio" id="${item.id}" name="Size${index}" value="${item.name}" form="${item.id}" 
                        variantid="${item.id}" availability="${item.availability == 'InStock' ? 'available' : 'unavailable'}" 
                        data-attr-size="${item.name}" data-attr-id="${item.id}">
                    <label class="variation-title swatch-label notranslate" for="${item.id}">
                        ${item.name}
                    </label>
                    <div class="variation-loader">.</div>
                    <div class="variation-cart-icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22.276" height="22.276" viewBox="0 0 25.276 25.276"><defs><clipPath id="a"><path d="M0-682.665H25.276v25.276H0Z" transform="translate(0 682.665)"></path></clipPath></defs><g transform="translate(0 -0.002)"><g transform="translate(0 0.002)"><g clip-path="url(#a)"><path d="M-521.561-468.368h-20.054l1.891-18.008h16.271Z" transform="translate(544.226 492.706)" fill="none" stroke="#000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.2"></path><path d="M0-201.931v-3.923A3.841,3.841,0,0,1,3.841-209.7h0a3.841,3.841,0,0,1,3.841,3.841v3.923" transform="translate(8.797 210.633)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.2"></path></g></g></g></svg></div>
                </div>`).join('')
             
                let swCollectionsImages = product.alternateImageUrls.slice(0,product.alternateImageUrls.length - 1 < 3 ? product.alternateImageUrls.length - 1 : 3).map((item) => `
                <div class="sw-slider-item">
                    <a href="${getUrl(product)}">
                        <img class="skeleton" src="" data-src="${item.replace(/v=\d+/, '')}height=600" alt="${product.name}" width="500" height="500" lazyLoad="sw_custom_lazy" >
                    </a>
                </div>`).join('')

                let swSliderDots = product.alternateImageUrls.slice(0,product.alternateImageUrls.length - 1 < 3 ? product.alternateImageUrls.length - 1 : 3).map((item) => `
                <span class="dot"></span>`).join('')

                let swProductTag = product.tags1?.map((item) => {
                    if (item.includes('Fit:')) {
                        const tagName = item.replace("Fit:", "");
                        return `<span>${(NostoConfig.translateBadge[tagName.toLowerCase()] && isArabLang) ? NostoConfig.translateBadge[tagName.toLowerCase()] : tagName}</span>`;
                    }

                    if (item.includes('offers')) {
                        const tagName = 'LIMITED TIME OFFER';

                        discountTag =`<span style="color: #F4564A; font-size: 10px; font-weight: 700">${(NostoConfig.translateBadge[tagName.toLowerCase()] && isArabLang) ? NostoConfig.translateBadge[tagName.toLowerCase()] : tagName.toUpperCase()}</span>`;
                    }

                }).join('')
                return `<div class="${product.tags1.includes('bundle') ? 'sw-bundle-card' : ''} card-wrapper sw-plp-filters-products__item sw-product-card-${product.productId} quickBuyEnable ${this.loadMoreScrollIntoView ? (index === 0 ? 'loadmore-scroll-into-view' : '') : ''}" id="${product.url.split('/').pop()}" data-product-id='${product.productId}' data-product-handle="${product.url.split('/').pop()}">
                                    
                        <div class="sw-plp-filters-products__media">
                            <div class="discount-percentage"></div>
                            <div class="sw-plp-filters-products__media-images">
                                <div class="sw-slider-item active">
                                    <a href="${getUrl(product)}">
                                        <img src="${product.imageUrl.replace(/v=\d+/, '')}height=600" alt="${product.name}" 
                                        width="500" height="500">
                                    </a>
                                </div>
                                    ${swCollectionsImages}
                                <div class="sw-slider-item last-slider">
                                    <a href="${getUrl(product)}">
                                        <img src="${product.alternateImageUrls[product.alternateImageUrls.length - 1]?.replace(/v=\d+/, '')}height=600" alt="${product.name}" 
                                        width="500" height="500">
                                        <div class="btn-vm">
                                            <div class="btn-vm-icon">+</div>
                                            <div class="btn-vm-txt">view more</div>
                                        </div>
                                    </a>
                                </div>
                                <div class="sw-slider-buttons">
                                    <button  class="sw-btn-left sw-disable" type="button">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14.645 12.204" style="transform: rotate(180deg)">
                                            <path id="Path_20" data-name="Path 20" d="M14.543,21.2l-.86-.86,4.625-4.631H6v-1.22H18.308L13.682,9.86l.86-.86,6.1,6.1Z" transform="translate(-6 -9)"></path>
                                        </svg>
                                    </button>
                                    <button class="sw-btn-right" type="button">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14.645 12.204">
                                            <path id="Path_20" data-name="Path 20" d="M14.543,21.2l-.86-.86,4.625-4.631H6v-1.22H18.308L13.682,9.86l.86-.86,6.1,6.1Z" transform="translate(-6 -9)"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div class="sw-slider-dots">
                                    <span class="dot active"></span>
                                    ${swSliderDots}
                                    <span class="dot"></span>
                                </div>
                                <div class="product-card-buttons">
                                    <div class="sw-toggle-box-quick-add-to-cart" id="sw-quick-buy-btn-${product.productId}" nosto-url="${getUrl(product)}" handle="${getUrl(product).split('/').pop()}">
                                        <div class="sw-toggle-quick-add-to-cart expand" data-attr-id="${product.productId}"> 
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 16.462 15.362">
                                                <g id="Group_104" data-name="Group 104" transform="translate(-1032.769 -191.177)">
                                                    <path id="Subtraction_5" data-name="Subtraction 5" d="M8.692,14.562H.347a.247.247,0,0,1-.184-.082A.244.244,0,0,1,.1,14.289L1.229,3.54a.247.247,0,0,1,.247-.221H3.793V2.64a2.539,2.539,0,1,1,5.079,0v.679h2.317a.247.247,0,0,1,.246.221l.231,2.21c-.162,0-.327.017-.492.038l-.207-1.975h-2.1V4.982a.247.247,0,0,1-.493,0V3.812H4.286V4.982a.247.247,0,0,1-.493,0V3.812H1.7L.621,14.068H8.164a4.988,4.988,0,0,0,.526.492ZM6.332.594A2.048,2.048,0,0,0,4.286,2.64v.679H8.378V2.64A2.048,2.048,0,0,0,6.332.594Z" transform="translate(1032.669 191.077)" fill="#222"></path>
                                                    <path id="Subtraction_4" data-name="Subtraction 4" d="M4.856,9.614A4.757,4.757,0,1,1,9.614,4.856,4.762,4.762,0,0,1,4.856,9.614Zm0-9.052a4.3,4.3,0,1,0,4.3,4.295A4.3,4.3,0,0,0,4.856.562Z" transform="translate(1039.617 196.925)" fill="#222"></path>
                                                    <path id="Subtraction_6" data-name="Subtraction 6" d="M2.251,4.3a.207.207,0,0,1-.207-.207V2.458H.408a.207.207,0,1,1,0-.414H2.044V.408A.208.208,0,0,1,2.251.2a.205.205,0,0,1,.207.208V2.044H4.1a.207.207,0,0,1,0,.414H2.458V4.093A.207.207,0,0,1,2.251,4.3Z" transform="translate(1042.223 199.631)" fill="#222"></path>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <fieldset class="js product-form__input h ${product.skus.length >= 2 ? '' : 'variation-single'}">
                                ${swCollectionsSwatches}
                            </fieldset>
                        </div>
                        <a href="${getUrl(product)}">
                            <h3 class="sw-plp-filters-products__title" 
                                data-handle="${getUrl(product).substring(getUrl(product).lastIndexOf('/') + 1)}">
                                ${product.name}
                            </h3>
                            ${discountTag}
                            <div class="product-price-container price skeleton skeleton-text" data-currency="${product.priceCurrencyCode}">
                                <span>${product.priceCurrencyCode} ${product.price.toFixed(2)}</span>
                                <span></span>

                            </div>
                            <div class="tags">${swProductTag}</div>
                        </a>
                </div>`
            })
            .join(''))
            .concat("</div>")
    }

    get = (key = 'data') => this[key] || []

    getFacets = () =>
        (this.get('facets') || [])
            .filter(facet =>
                !NostoConfig.excludedFacets
                    .includes(facet.name.toLowerCase()))

    getLocale = () => {
        let segment = ''

        if (window.Shopify.country !== 'AE' || isArabLang) {

            segment = '/en'
            if (isArabLang) {
                segment = '/ar'
            }

            if (window.Shopify.country !== 'AE') {
                segment += '-' + window.Shopify.country.toLowerCase()
            }
        }

        return segment
    }

    resolveProductAttributes = async (handle) => {

        const getProductData = async () => {

            let url = window.shopUrl
            let segment = this.getLocale()

            url = `${url}${segment}/products/${handle}.js`
            const response = await fetch(url)

            if (!response.ok) {
                throw new Error(`API request failed with status: ${response.status}`)
            }

            let data = await response.json()

            // assigning handle
            data = Object.assign(
                {},
                {
                    handle,
                    title: data.title,
                    compare_at_price: data.compare_at_price,
                    price: data.price,
                })

            // Deleting an item
            this.localDb.deleteItem(handle)
            // adding/refreshing old item
            this.localDb.addItem(data)
            return data
        }

        const item = await this.localDb.getItem(handle)
        if (item !== null && item !== undefined) {
            // queue operation to refresh data
            setTimeout(async () => {
                // refresh cache
                const data = await getProductData(handle)
                // get element by handle
                const product = document.querySelector(`[data-handle="${handle}"].sw-plp-filters-products__title`)

                if (data && Object.keys(data).length && product) {
                    // update the attributes as per new data
                    this.updateProductAttributes(data, product)
                }
            }, 1000)

            return item
        }

        return await getProductData(handle)
    }

    initRangeFacet = () => {
        const minThumb = document.getElementById('minThumb');
        const maxThumb = document.getElementById('maxThumb');
        const minValueDisplay = document.getElementById('minValue');
        const maxValueDisplay = document.getElementById('maxValue');
        const sliderTrackHigh = document.getElementById('sliderTrackHigh');
        const filter = getQueryParams(NostoConfig.filterUrlKey.concat('.price'));

        const getMinVal = () => {
            if (filter && filter.length && filter.split('~')[0] && filter.split('~')[0].length) {
                return Math.round(parseInt(filter.split('~')[0]) * window.Shopify.currency.rate);
            }
            return parseInt(minThumb.innerText)
        }

        const getMaxVal = () => {
            if (filter && filter.length && filter.split('~')[1] && filter.split('~')[1].length) {
                return Math.round(parseInt(filter.split('~')[1]) * window.Shopify.currency.rate);
            }
            return parseInt(maxThumb.innerText)
        }

        const getSliderDimensions = () => {
            const sliderTrack = document.querySelector('.slider-track');
            const sliderTrackRect = sliderTrack.getBoundingClientRect();
            const sliderWidth = sliderTrackRect.width;
            return { sliderTrackRect, sliderWidth };
        }

        let minVal = getMinVal();
        let maxVal = getMaxVal();
        let minRange = parseInt(minThumb.innerText);
        let maxRange = parseInt(maxThumb.innerText);

        const setThumbPosition = (minThumb, maxThumb, minVal, maxVal) => {
            const minPercent = ((minVal - minRange) / (maxRange - minRange)) * 100;
            const maxPercent = ((maxVal - minRange) / (maxRange - minRange)) * 100;


            minThumb.style.left = minValueDisplay.value < minRange ? `0%` : `calc(${minPercent}%)`;
            maxThumb.style.left = maxValueDisplay.value > maxRange ? `100%` : `calc(${maxPercent}% - 10px)`;
        }

        const updateValues = () => {
            minValueDisplay.value = minVal;
            maxValueDisplay.value = maxVal;
            setThumbPosition(minThumb, maxThumb, minVal, maxVal);

            sliderTrackHigh.style.left = minValueDisplay.value < minRange ? `0%` : `${((minVal - minRange) / (maxRange - minRange)) * 100}%`;
            sliderTrackHigh.style.right = maxValueDisplay.value > maxRange ? `0%` : `${100 - ((maxVal - minRange) / (maxRange - minRange)) * 100}%`;

        }

        const handleMove = (event, isMin) => {
            const { sliderTrackRect, sliderWidth } = getSliderDimensions();
            const clientX = event.touches ? event.touches[0].clientX : event.clientX;
            const newLeft = clientX - sliderTrackRect.left;
            let newValue = Math.round((newLeft / sliderWidth) * (maxRange - minRange) + minRange);

            if (isMin) {
                if (newValue < minRange) newValue = minRange;
                if (newValue > maxVal - 1) newValue = maxVal - 1;
                minVal = newValue;
            } else {
                if (newValue < minVal + 1) newValue = minVal + 1;
                if (newValue > maxRange) newValue = maxRange;
                maxVal = newValue;
            }

            updateValues(); // update values on thumb move to make range slider responsive to user action
            setThumbPosition(minThumb, maxThumb, minVal, maxVal);

            sliderTrackHigh.style.left = minValueDisplay.value < minRange ? `0%` : `${((minVal - minRange) / (maxRange - minRange)) * 100}%`;
            sliderTrackHigh.style.right = maxValueDisplay.value > maxRange ? `0%` : `${100 - ((maxVal - minRange) / (maxRange - minRange)) * 100}%`;

        }

        // this will trigger input event on both min and max range input to execute event listener (applyRangeFilter)
        const triggerChange = isMin => {

            if (isMin) {
                minValueDisplay.dispatchEvent(new Event('input'))
            } else {
                maxValueDisplay.dispatchEvent(new Event('input'))
            }
        }

        const addEventListeners = (thumb, isMin) => {
            thumb.addEventListener('mousedown', event => {
                event.preventDefault();
                document.onmousemove = event => handleMove(event, isMin);
                document.onmouseup = () => {
                    // reset page no and update query params
                    this.pageNo = 1
                    this.nextPage = 1
                    this.prevPage = 0
                    document.getElementById('products').innerHTML = ''
                    addOrUpdateQueryParam(`${NostoConfig.pageSizeUrlKey}`, this.pageNo)

                    document.onmousemove = null;
                    document.onmouseup = null;
                    triggerChange(isMin)
                };
            });

            thumb.addEventListener('touchstart', event => {
                event.preventDefault();
                document.ontouchmove = event => handleMove(event, isMin);
                document.ontouchend = () => {
                    // reset page no and update query params
                    this.pageNo = 1
                    this.nextPage = 1
                    this.prevPage = 0
                    document.getElementById('products').innerHTML = ''
                    addOrUpdateQueryParam(`${NostoConfig.pageSizeUrlKey}`, this.pageNo)

                    document.ontouchmove = null;
                    document.ontouchend = null;
                    triggerChange(isMin)
                };
            });
        }

        addEventListeners(minThumb, true);
        addEventListeners(maxThumb, false);
        updateValues();
    }

    swTransitionUnset = () => {
        document.getElementById('swFilterDrawer').style.transition = 'unset';
        document.querySelector('.sw-plp-filters__grp-btn .sw-filter-drawer-overlay').style.transition = 'unset';
        document.getElementById('swFilterDrawer').classList.add('sw-drawer-active');
    }

    updateProductAttributes = (product, productElement) => {

        const moneyFormat = Shopify.nosto.money_format.split('{{').pop().split('}}')[0];
        const currency = window.Shopify?.currency?.active || productElement.nextElementSibling?.dataset?.currency
        //const actualPriceElement = productElement.nextElementSibling.children[0]
        const priceContainer = productElement.parentElement.querySelector('.product-price-container')
        const actualPriceElement = priceContainer.children[0]
        //const priceLoader = productElement.nextElementSibling
        const formatNumber = input => {
            let number = typeof input === 'string' ? parseFloat(input) : input;
            return (number / 100).toFixed(2);
        }

        // setting the price of product from shopify
        actualPriceElement.innerText = `${getCurrency(currency)} ${formatMoney(convertCurrency(product.compare_at_price || product.price), "{{" + moneyFormat + "}}")}`
        priceContainer.classList.remove('skeleton'); // ending price loader
        priceContainer.classList.remove('skeleton-text'); // ending price loader
        if (product.price && product.compare_at_price && product.price !== product.compare_at_price) {
            const discountAmount = product.compare_at_price - product.price;
            const discountPercentageBeforeRounding = parseFloat(((discountAmount / product.compare_at_price) * 100).toFixed(2));
            const discountPercentage = Math.round(discountPercentageBeforeRounding / 5) * 5;
            const discountedPriceElement = priceContainer.children[1]
            const discountedPercentageElement = productElement.parentElement.parentElement.querySelector('.discount-percentage')

            discountedPercentageElement.innerHTML = `${discountPercentage}%`
            actualPriceElement.style.textDecoration = 'line-through'

            discountedPriceElement.innerText = `${getCurrency(currency)} ${formatMoney(convertCurrency(product.price), "{{" + moneyFormat + "}}")}`
        }

        // only for arabic
        if (isArabLang) {
            productElement.innerText = product.title
        }
    }
    
    initDomEvents = () => {
        // it will apply lazy load for image
        LAZYLOAD.lazyLoadImagesInView();
        swNostoAddClass('.sw-plp-filters__btn');
        swNostoGridIcon();
        swNostoProductSlider(this?.data?.products?.hits || []);
        swNostoQuickBuy(".sw-plp-filters-products .sw-toggle-box-quick-add-to-cart");
        swFilterDrawer('swFilterDrawerBtn', 'swFilterDrawer', 'swFilterDrawerCloseBtn');
        swNostoPostScroll(this?.data?.products?.hits || [])
    }

    handlePostRenderActions = () => {

        // scroll to first child when click on load prev
        this.scrollOnProduct()

        // attach the intersection observer to autoload more on scroll bottom
        this.scrollLoadMore()

        // ended loader again just to make sure that dom existed
        this.endLoading()

        if(this.data.products === null || !this.data.products.hasOwnProperty('hits')){
            return;
        }

        // this will bind the events to range facet (range slider)
        this.initRangeFacet()

        this.data.products.hits.map(hit => hit.productId)
            .forEach(async (id) => {

                let prod = document.querySelectorAll(`[data-product-id="${id}"] .sw-plp-filters-products__title`)
                prod.forEach(async (prod) => {

                    const handle = prod.dataset.handle
                    const product = await this.resolveProductAttributes(handle)

                    this.updateProductAttributes(product, prod)
                })
            })

             // this will bind the dom events for (filter,button,slider etc...)
            this.initDomEvents()

    }

    getProductNotFound = () => {
        if (this.data.products === null || this.data.products.hits.length === 0) {
            return `<h2>no results found</h2>`
        }
        return ''
    }

    render = () => {
        document.getElementById('selected-filters').innerHTML = this.getSelectedFilters()
        document.getElementById('facets').innerHTML = this.getFacetsToolbar()
        document.getElementById('products').insertAdjacentHTML(this.position, this.getProductCollection())
        document.getElementById('product-not-found').innerHTML = this.getProductNotFound()
        document.getElementById('load-more').innerHTML = this.getLoadMore()
        document.getElementById('load-prev').innerHTML = this.getLoadPrev()

        this.handlePostRenderActions()
    }

    // Wrapper functions for specific Nosto API endpoints (replace with your desired functions)
    getProducts = async (filters = {}) => {
        return null
        const query = `
      query getProducts($filters: ProductFilterInput) {
        products(filters: $filters) {
          id
          name
          image
          # Add other product fields as needed
        }
      }
    `

        const response = await this.fetchData(query, { filters })
        return response.data.products
    }

    getSessionParamsForRequest = async () => {

        return JSON.parse(sessionStorage.getItem('nosto:search:sessionParams:v2'))
    }
}


let _nostoClient = null

swNosto = () => {
    if (_nostoClient === null) {
        _nostoClient = new NostoGraphQLClient()
    }
    return _nostoClient
}